import axios from "axios";

export const hotelFinanceURL = "https://staging-api.rrooms.in/";
// export const mainUrl = "https://api.rrooms.in/";
// export const mainUrl = "http://13.233.100.193/";
export const mainUrl = "https://rrooms.in/rrooms/";
// export const mainUrl = "http://localhost:4000/";
// export const secUrl = "https://rrooms.in/api/";

const api = axios.create({
  baseURL: `${mainUrl}api/`,
  // baseURL: `${hotelFinanceURL}api/`,
});
export default api;

export const baseUrl = `${mainUrl}api/`;
// export const baseImgUrl = `${mainUrl}images/`;
export const baseImgUrl = `${mainUrl}uploads/`;
